<div class="container-fluid">
  <div class="row">
    <div class="col-12 px-0">
      <div class="card p-0 border-0 animate-fade-in shadow-none">
        <div class="card-body p-3">
          <!-- Header Section -->
          <div class="d-flex flex-row flex-wrap justify-content-between align-items-center mb-4">
            <div class="d-flex align-items-center">
              <button class="btn btn-icon me-3 border" routerLink="/expenses">
                <i class="bi bi-arrow-left"></i>
              </button>
              <div>
                <h1 class="card-title mb-1">Employee Travel Reports</h1>
                <span class="sub-text">Select an employee to view their daily travel logs</span>
              </div>
            </div>
          </div>

          <!-- Employee Search -->
          <div class="row mb-3">
            <div class="col-12 px-0">
              <div class="input-group">
                <span class="input-group-text bg-white border-end-0">
                  <i class="bi bi-search text-muted"></i>
                </span>
                <input
                  type="text"
                  class="form-control border-start-0"
                  placeholder="Search employees by name or email..."
                  [(ngModel)]="searchTerm"
                  (keyup)="onSearchKeyUp()" />
                @if (searchTerm) {
                  <button class="btn btn-outline-secondary border-start-0" (click)="onClearSearch()" title="Clear">
                    <i class="bi bi-x-lg"></i>
                  </button>
                }
              </div>
            </div>
          </div>

          @if (isLoading) {
            <app-loading-spinner></app-loading-spinner>
          } @else {
            @if ((employees || []).length === 0) {
              <div class="empty-state-container">
                <i class="bi bi-people"></i>
                <h5 class="text-dark fw-bold">No Employees Found</h5>
                <p class="text-muted mb-4">No employees found matching your search criteria.</p>
              </div>
            } @else {
              <div class="table-responsive">
                <table class="table table-hover align-middle mb-0">
                  <thead class="bg-light">
                    <tr>
                      <th class="ps-4 border-0 text-uppercase small fw-bold text-muted py-3">Team Member</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Designation</th>
                      <th class="border-0 text-uppercase small fw-bold text-muted py-3">Joined On</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (emp of employees; track emp.id) {
                      <tr
                        class="cursor-pointer transition-all border-bottom"
                        [routerLink]="['/expenses/travel-reports', emp.id]">
                        <td class="ps-4 py-3">
                          <div class="d-flex align-items-center">
                            <img
                              [src]="
                                emp.user.profile_picture ||
                                getDefaultProfilePicUrl(emp.user.first_name, emp.user.last_name)
                              "
                              alt="{{ emp.user.first_name }} {{ emp.user.last_name }}"
                              class="rounded-circle border border-2 border-white shadow-sm bg-light"
                              width="42"
                              height="42"
                              (error)="handleImageError($event)" />
                            <div class="ms-3">
                              <div class="fw-bold text-dark">
                                {{ emp.user.first_name + ' ' + emp.user.last_name }}
                              </div>
                              <div class="small text-muted">{{ emp.user.email }}</div>
                            </div>
                          </div>
                        </td>
                        <td class="py-3">
                          <span class="fw-semibold text-dark">{{ emp.designation.title }}</span>
                        </td>
                        <td class="py-3">
                          <span class="text-muted small">
                            <i class="bi bi-calendar3 me-1"></i>
                            {{ emp.date_of_joining | date }}
                          </span>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>

              <div class="mt-4">
                <app-pagination
                  [currentPage]="currentPage"
                  [totalCount]="totalCount"
                  [pageSize]="10"
                  [hasNextPage]="hasNextPage"
                  [hasPreviousPage]="hasPreviousPage"
                  (pageChange)="onPageChange($event)"></app-pagination>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>
